import {
  getPageRouteFromPathname,
  stripDarkFromRoute,
  getDocumentLocation,
} from '@nike/ux-tread-dotcom-utils';

export default () => {
  const { pathname } = getDocumentLocation();
  return stripDarkFromRoute(getPageRouteFromPathname(pathname));
};
